import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _construct from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/construct.js";

function bindNew(Class) {
  function _Class() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _construct(Class, args);
  }

  _Class.prototype = Class.prototype;
  return _Class;
}

export var classes = new Map();

var _BatchMeta = /*#__PURE__*/function () {
  function _BatchMeta(pageNo, firstIndex, timestamp) {
    _classCallCheck(this, _BatchMeta);

    this.pageNo = pageNo;
    this.firstIndex = firstIndex;
    this.timestamp = timestamp;
    this._id = 80;
  }

  _createClass(_BatchMeta, [{
    key: "encode",
    value: function encode(writer) {
      return writer.uint(80) && writer.uint(this.pageNo) && writer.uint(this.firstIndex) && writer.int(this.timestamp);
    }
  }]);

  return _BatchMeta;
}();

export var BatchMeta = bindNew(_BatchMeta);
classes.set(80, BatchMeta);

var _Timestamp = /*#__PURE__*/function () {
  function _Timestamp(timestamp) {
    _classCallCheck(this, _Timestamp);

    this.timestamp = timestamp;
    this._id = 0;
  }

  _createClass(_Timestamp, [{
    key: "encode",
    value: function encode(writer) {
      return writer.uint(0) && writer.uint(this.timestamp);
    }
  }]);

  return _Timestamp;
}();

export var Timestamp = bindNew(_Timestamp);
classes.set(0, Timestamp);

var _SetPageLocation = /*#__PURE__*/function () {
  function _SetPageLocation(url, referrer, navigationStart) {
    _classCallCheck(this, _SetPageLocation);

    this.url = url;
    this.referrer = referrer;
    this.navigationStart = navigationStart;
    this._id = 4;
  }

  _createClass(_SetPageLocation, [{
    key: "encode",
    value: function encode(writer) {
      return writer.uint(4) && writer.string(this.url) && writer.string(this.referrer) && writer.uint(this.navigationStart);
    }
  }]);

  return _SetPageLocation;
}();

export var SetPageLocation = bindNew(_SetPageLocation);
classes.set(4, SetPageLocation);

var _SetViewportSize = /*#__PURE__*/function () {
  function _SetViewportSize(width, height) {
    _classCallCheck(this, _SetViewportSize);

    this.width = width;
    this.height = height;
    this._id = 5;
  }

  _createClass(_SetViewportSize, [{
    key: "encode",
    value: function encode(writer) {
      return writer.uint(5) && writer.uint(this.width) && writer.uint(this.height);
    }
  }]);

  return _SetViewportSize;
}();

export var SetViewportSize = bindNew(_SetViewportSize);
classes.set(5, SetViewportSize);

var _SetViewportScroll = /*#__PURE__*/function () {
  function _SetViewportScroll(x, y) {
    _classCallCheck(this, _SetViewportScroll);

    this.x = x;
    this.y = y;
    this._id = 6;
  }

  _createClass(_SetViewportScroll, [{
    key: "encode",
    value: function encode(writer) {
      return writer.uint(6) && writer.int(this.x) && writer.int(this.y);
    }
  }]);

  return _SetViewportScroll;
}();

export var SetViewportScroll = bindNew(_SetViewportScroll);
classes.set(6, SetViewportScroll);

var _CreateDocument = /*#__PURE__*/function () {
  function _CreateDocument() {
    _classCallCheck(this, _CreateDocument);

    this._id = 7;
  }

  _createClass(_CreateDocument, [{
    key: "encode",
    value: function encode(writer) {
      return writer.uint(7);
    }
  }]);

  return _CreateDocument;
}();

export var CreateDocument = bindNew(_CreateDocument);
classes.set(7, CreateDocument);

var _CreateElementNode = /*#__PURE__*/function () {
  function _CreateElementNode(id, parentID, index, tag, svg) {
    _classCallCheck(this, _CreateElementNode);

    this.id = id;
    this.parentID = parentID;
    this.index = index;
    this.tag = tag;
    this.svg = svg;
    this._id = 8;
  }

  _createClass(_CreateElementNode, [{
    key: "encode",
    value: function encode(writer) {
      return writer.uint(8) && writer.uint(this.id) && writer.uint(this.parentID) && writer.uint(this.index) && writer.string(this.tag) && writer.boolean(this.svg);
    }
  }]);

  return _CreateElementNode;
}();

export var CreateElementNode = bindNew(_CreateElementNode);
classes.set(8, CreateElementNode);

var _CreateTextNode = /*#__PURE__*/function () {
  function _CreateTextNode(id, parentID, index) {
    _classCallCheck(this, _CreateTextNode);

    this.id = id;
    this.parentID = parentID;
    this.index = index;
    this._id = 9;
  }

  _createClass(_CreateTextNode, [{
    key: "encode",
    value: function encode(writer) {
      return writer.uint(9) && writer.uint(this.id) && writer.uint(this.parentID) && writer.uint(this.index);
    }
  }]);

  return _CreateTextNode;
}();

export var CreateTextNode = bindNew(_CreateTextNode);
classes.set(9, CreateTextNode);

var _MoveNode = /*#__PURE__*/function () {
  function _MoveNode(id, parentID, index) {
    _classCallCheck(this, _MoveNode);

    this.id = id;
    this.parentID = parentID;
    this.index = index;
    this._id = 10;
  }

  _createClass(_MoveNode, [{
    key: "encode",
    value: function encode(writer) {
      return writer.uint(10) && writer.uint(this.id) && writer.uint(this.parentID) && writer.uint(this.index);
    }
  }]);

  return _MoveNode;
}();

export var MoveNode = bindNew(_MoveNode);
classes.set(10, MoveNode);

var _RemoveNode = /*#__PURE__*/function () {
  function _RemoveNode(id) {
    _classCallCheck(this, _RemoveNode);

    this.id = id;
    this._id = 11;
  }

  _createClass(_RemoveNode, [{
    key: "encode",
    value: function encode(writer) {
      return writer.uint(11) && writer.uint(this.id);
    }
  }]);

  return _RemoveNode;
}();

export var RemoveNode = bindNew(_RemoveNode);
classes.set(11, RemoveNode);

var _SetNodeAttribute = /*#__PURE__*/function () {
  function _SetNodeAttribute(id, name, value) {
    _classCallCheck(this, _SetNodeAttribute);

    this.id = id;
    this.name = name;
    this.value = value;
    this._id = 12;
  }

  _createClass(_SetNodeAttribute, [{
    key: "encode",
    value: function encode(writer) {
      return writer.uint(12) && writer.uint(this.id) && writer.string(this.name) && writer.string(this.value);
    }
  }]);

  return _SetNodeAttribute;
}();

export var SetNodeAttribute = bindNew(_SetNodeAttribute);
classes.set(12, SetNodeAttribute);

var _RemoveNodeAttribute = /*#__PURE__*/function () {
  function _RemoveNodeAttribute(id, name) {
    _classCallCheck(this, _RemoveNodeAttribute);

    this.id = id;
    this.name = name;
    this._id = 13;
  }

  _createClass(_RemoveNodeAttribute, [{
    key: "encode",
    value: function encode(writer) {
      return writer.uint(13) && writer.uint(this.id) && writer.string(this.name);
    }
  }]);

  return _RemoveNodeAttribute;
}();

export var RemoveNodeAttribute = bindNew(_RemoveNodeAttribute);
classes.set(13, RemoveNodeAttribute);

var _SetNodeData = /*#__PURE__*/function () {
  function _SetNodeData(id, data) {
    _classCallCheck(this, _SetNodeData);

    this.id = id;
    this.data = data;
    this._id = 14;
  }

  _createClass(_SetNodeData, [{
    key: "encode",
    value: function encode(writer) {
      return writer.uint(14) && writer.uint(this.id) && writer.string(this.data);
    }
  }]);

  return _SetNodeData;
}();

export var SetNodeData = bindNew(_SetNodeData);
classes.set(14, SetNodeData);

var _SetNodeScroll = /*#__PURE__*/function () {
  function _SetNodeScroll(id, x, y) {
    _classCallCheck(this, _SetNodeScroll);

    this.id = id;
    this.x = x;
    this.y = y;
    this._id = 16;
  }

  _createClass(_SetNodeScroll, [{
    key: "encode",
    value: function encode(writer) {
      return writer.uint(16) && writer.uint(this.id) && writer.int(this.x) && writer.int(this.y);
    }
  }]);

  return _SetNodeScroll;
}();

export var SetNodeScroll = bindNew(_SetNodeScroll);
classes.set(16, SetNodeScroll);

var _SetInputTarget = /*#__PURE__*/function () {
  function _SetInputTarget(id, label) {
    _classCallCheck(this, _SetInputTarget);

    this.id = id;
    this.label = label;
    this._id = 17;
  }

  _createClass(_SetInputTarget, [{
    key: "encode",
    value: function encode(writer) {
      return writer.uint(17) && writer.uint(this.id) && writer.string(this.label);
    }
  }]);

  return _SetInputTarget;
}();

export var SetInputTarget = bindNew(_SetInputTarget);
classes.set(17, SetInputTarget);

var _SetInputValue = /*#__PURE__*/function () {
  function _SetInputValue(id, value, mask) {
    _classCallCheck(this, _SetInputValue);

    this.id = id;
    this.value = value;
    this.mask = mask;
    this._id = 18;
  }

  _createClass(_SetInputValue, [{
    key: "encode",
    value: function encode(writer) {
      return writer.uint(18) && writer.uint(this.id) && writer.string(this.value) && writer.int(this.mask);
    }
  }]);

  return _SetInputValue;
}();

export var SetInputValue = bindNew(_SetInputValue);
classes.set(18, SetInputValue);

var _SetInputChecked = /*#__PURE__*/function () {
  function _SetInputChecked(id, checked) {
    _classCallCheck(this, _SetInputChecked);

    this.id = id;
    this.checked = checked;
    this._id = 19;
  }

  _createClass(_SetInputChecked, [{
    key: "encode",
    value: function encode(writer) {
      return writer.uint(19) && writer.uint(this.id) && writer.boolean(this.checked);
    }
  }]);

  return _SetInputChecked;
}();

export var SetInputChecked = bindNew(_SetInputChecked);
classes.set(19, SetInputChecked);

var _MouseMove = /*#__PURE__*/function () {
  function _MouseMove(x, y) {
    _classCallCheck(this, _MouseMove);

    this.x = x;
    this.y = y;
    this._id = 20;
  }

  _createClass(_MouseMove, [{
    key: "encode",
    value: function encode(writer) {
      return writer.uint(20) && writer.uint(this.x) && writer.uint(this.y);
    }
  }]);

  return _MouseMove;
}();

export var MouseMove = bindNew(_MouseMove);
classes.set(20, MouseMove);

var _ConsoleLog = /*#__PURE__*/function () {
  function _ConsoleLog(level, value) {
    _classCallCheck(this, _ConsoleLog);

    this.level = level;
    this.value = value;
    this._id = 22;
  }

  _createClass(_ConsoleLog, [{
    key: "encode",
    value: function encode(writer) {
      return writer.uint(22) && writer.string(this.level) && writer.string(this.value);
    }
  }]);

  return _ConsoleLog;
}();

export var ConsoleLog = bindNew(_ConsoleLog);
classes.set(22, ConsoleLog);

var _PageLoadTiming = /*#__PURE__*/function () {
  function _PageLoadTiming(requestStart, responseStart, responseEnd, domContentLoadedEventStart, domContentLoadedEventEnd, loadEventStart, loadEventEnd, firstPaint, firstContentfulPaint) {
    _classCallCheck(this, _PageLoadTiming);

    this.requestStart = requestStart;
    this.responseStart = responseStart;
    this.responseEnd = responseEnd;
    this.domContentLoadedEventStart = domContentLoadedEventStart;
    this.domContentLoadedEventEnd = domContentLoadedEventEnd;
    this.loadEventStart = loadEventStart;
    this.loadEventEnd = loadEventEnd;
    this.firstPaint = firstPaint;
    this.firstContentfulPaint = firstContentfulPaint;
    this._id = 23;
  }

  _createClass(_PageLoadTiming, [{
    key: "encode",
    value: function encode(writer) {
      return writer.uint(23) && writer.uint(this.requestStart) && writer.uint(this.responseStart) && writer.uint(this.responseEnd) && writer.uint(this.domContentLoadedEventStart) && writer.uint(this.domContentLoadedEventEnd) && writer.uint(this.loadEventStart) && writer.uint(this.loadEventEnd) && writer.uint(this.firstPaint) && writer.uint(this.firstContentfulPaint);
    }
  }]);

  return _PageLoadTiming;
}();

export var PageLoadTiming = bindNew(_PageLoadTiming);
classes.set(23, PageLoadTiming);

var _PageRenderTiming = /*#__PURE__*/function () {
  function _PageRenderTiming(speedIndex, visuallyComplete, timeToInteractive) {
    _classCallCheck(this, _PageRenderTiming);

    this.speedIndex = speedIndex;
    this.visuallyComplete = visuallyComplete;
    this.timeToInteractive = timeToInteractive;
    this._id = 24;
  }

  _createClass(_PageRenderTiming, [{
    key: "encode",
    value: function encode(writer) {
      return writer.uint(24) && writer.uint(this.speedIndex) && writer.uint(this.visuallyComplete) && writer.uint(this.timeToInteractive);
    }
  }]);

  return _PageRenderTiming;
}();

export var PageRenderTiming = bindNew(_PageRenderTiming);
classes.set(24, PageRenderTiming);

var _JSException = /*#__PURE__*/function () {
  function _JSException(name, message, payload) {
    _classCallCheck(this, _JSException);

    this.name = name;
    this.message = message;
    this.payload = payload;
    this._id = 25;
  }

  _createClass(_JSException, [{
    key: "encode",
    value: function encode(writer) {
      return writer.uint(25) && writer.string(this.name) && writer.string(this.message) && writer.string(this.payload);
    }
  }]);

  return _JSException;
}();

export var JSException = bindNew(_JSException);
classes.set(25, JSException);

var _RawCustomEvent = /*#__PURE__*/function () {
  function _RawCustomEvent(name, payload) {
    _classCallCheck(this, _RawCustomEvent);

    this.name = name;
    this.payload = payload;
    this._id = 27;
  }

  _createClass(_RawCustomEvent, [{
    key: "encode",
    value: function encode(writer) {
      return writer.uint(27) && writer.string(this.name) && writer.string(this.payload);
    }
  }]);

  return _RawCustomEvent;
}();

export var RawCustomEvent = bindNew(_RawCustomEvent);
classes.set(27, RawCustomEvent);

var _UserID = /*#__PURE__*/function () {
  function _UserID(id) {
    _classCallCheck(this, _UserID);

    this.id = id;
    this._id = 28;
  }

  _createClass(_UserID, [{
    key: "encode",
    value: function encode(writer) {
      return writer.uint(28) && writer.string(this.id);
    }
  }]);

  return _UserID;
}();

export var UserID = bindNew(_UserID);
classes.set(28, UserID);

var _UserAnonymousID = /*#__PURE__*/function () {
  function _UserAnonymousID(id) {
    _classCallCheck(this, _UserAnonymousID);

    this.id = id;
    this._id = 29;
  }

  _createClass(_UserAnonymousID, [{
    key: "encode",
    value: function encode(writer) {
      return writer.uint(29) && writer.string(this.id);
    }
  }]);

  return _UserAnonymousID;
}();

export var UserAnonymousID = bindNew(_UserAnonymousID);
classes.set(29, UserAnonymousID);

var _Metadata = /*#__PURE__*/function () {
  function _Metadata(key, value) {
    _classCallCheck(this, _Metadata);

    this.key = key;
    this.value = value;
    this._id = 30;
  }

  _createClass(_Metadata, [{
    key: "encode",
    value: function encode(writer) {
      return writer.uint(30) && writer.string(this.key) && writer.string(this.value);
    }
  }]);

  return _Metadata;
}();

export var Metadata = bindNew(_Metadata);
classes.set(30, Metadata);

var _CSSInsertRule = /*#__PURE__*/function () {
  function _CSSInsertRule(id, rule, index) {
    _classCallCheck(this, _CSSInsertRule);

    this.id = id;
    this.rule = rule;
    this.index = index;
    this._id = 37;
  }

  _createClass(_CSSInsertRule, [{
    key: "encode",
    value: function encode(writer) {
      return writer.uint(37) && writer.uint(this.id) && writer.string(this.rule) && writer.uint(this.index);
    }
  }]);

  return _CSSInsertRule;
}();

export var CSSInsertRule = bindNew(_CSSInsertRule);
classes.set(37, CSSInsertRule);

var _CSSDeleteRule = /*#__PURE__*/function () {
  function _CSSDeleteRule(id, index) {
    _classCallCheck(this, _CSSDeleteRule);

    this.id = id;
    this.index = index;
    this._id = 38;
  }

  _createClass(_CSSDeleteRule, [{
    key: "encode",
    value: function encode(writer) {
      return writer.uint(38) && writer.uint(this.id) && writer.uint(this.index);
    }
  }]);

  return _CSSDeleteRule;
}();

export var CSSDeleteRule = bindNew(_CSSDeleteRule);
classes.set(38, CSSDeleteRule);

var _Fetch = /*#__PURE__*/function () {
  function _Fetch(method, url, request, response, status, timestamp, duration) {
    _classCallCheck(this, _Fetch);

    this.method = method;
    this.url = url;
    this.request = request;
    this.response = response;
    this.status = status;
    this.timestamp = timestamp;
    this.duration = duration;
    this._id = 39;
  }

  _createClass(_Fetch, [{
    key: "encode",
    value: function encode(writer) {
      return writer.uint(39) && writer.string(this.method) && writer.string(this.url) && writer.string(this.request) && writer.string(this.response) && writer.uint(this.status) && writer.uint(this.timestamp) && writer.uint(this.duration);
    }
  }]);

  return _Fetch;
}();

export var Fetch = bindNew(_Fetch);
classes.set(39, Fetch);

var _Profiler = /*#__PURE__*/function () {
  function _Profiler(name, duration, args, result) {
    _classCallCheck(this, _Profiler);

    this.name = name;
    this.duration = duration;
    this.args = args;
    this.result = result;
    this._id = 40;
  }

  _createClass(_Profiler, [{
    key: "encode",
    value: function encode(writer) {
      return writer.uint(40) && writer.string(this.name) && writer.uint(this.duration) && writer.string(this.args) && writer.string(this.result);
    }
  }]);

  return _Profiler;
}();

export var Profiler = bindNew(_Profiler);
classes.set(40, Profiler);

var _OTable = /*#__PURE__*/function () {
  function _OTable(key, value) {
    _classCallCheck(this, _OTable);

    this.key = key;
    this.value = value;
    this._id = 41;
  }

  _createClass(_OTable, [{
    key: "encode",
    value: function encode(writer) {
      return writer.uint(41) && writer.string(this.key) && writer.string(this.value);
    }
  }]);

  return _OTable;
}();

export var OTable = bindNew(_OTable);
classes.set(41, OTable);

var _StateAction = /*#__PURE__*/function () {
  function _StateAction(type) {
    _classCallCheck(this, _StateAction);

    this.type = type;
    this._id = 42;
  }

  _createClass(_StateAction, [{
    key: "encode",
    value: function encode(writer) {
      return writer.uint(42) && writer.string(this.type);
    }
  }]);

  return _StateAction;
}();

export var StateAction = bindNew(_StateAction);
classes.set(42, StateAction);

var _Redux = /*#__PURE__*/function () {
  function _Redux(action, state, duration) {
    _classCallCheck(this, _Redux);

    this.action = action;
    this.state = state;
    this.duration = duration;
    this._id = 44;
  }

  _createClass(_Redux, [{
    key: "encode",
    value: function encode(writer) {
      return writer.uint(44) && writer.string(this.action) && writer.string(this.state) && writer.uint(this.duration);
    }
  }]);

  return _Redux;
}();

export var Redux = bindNew(_Redux);
classes.set(44, Redux);

var _Vuex = /*#__PURE__*/function () {
  function _Vuex(mutation, state) {
    _classCallCheck(this, _Vuex);

    this.mutation = mutation;
    this.state = state;
    this._id = 45;
  }

  _createClass(_Vuex, [{
    key: "encode",
    value: function encode(writer) {
      return writer.uint(45) && writer.string(this.mutation) && writer.string(this.state);
    }
  }]);

  return _Vuex;
}();

export var Vuex = bindNew(_Vuex);
classes.set(45, Vuex);

var _MobX = /*#__PURE__*/function () {
  function _MobX(type, payload) {
    _classCallCheck(this, _MobX);

    this.type = type;
    this.payload = payload;
    this._id = 46;
  }

  _createClass(_MobX, [{
    key: "encode",
    value: function encode(writer) {
      return writer.uint(46) && writer.string(this.type) && writer.string(this.payload);
    }
  }]);

  return _MobX;
}();

export var MobX = bindNew(_MobX);
classes.set(46, MobX);

var _NgRx = /*#__PURE__*/function () {
  function _NgRx(action, state, duration) {
    _classCallCheck(this, _NgRx);

    this.action = action;
    this.state = state;
    this.duration = duration;
    this._id = 47;
  }

  _createClass(_NgRx, [{
    key: "encode",
    value: function encode(writer) {
      return writer.uint(47) && writer.string(this.action) && writer.string(this.state) && writer.uint(this.duration);
    }
  }]);

  return _NgRx;
}();

export var NgRx = bindNew(_NgRx);
classes.set(47, NgRx);

var _GraphQL = /*#__PURE__*/function () {
  function _GraphQL(operationKind, operationName, variables, response) {
    _classCallCheck(this, _GraphQL);

    this.operationKind = operationKind;
    this.operationName = operationName;
    this.variables = variables;
    this.response = response;
    this._id = 48;
  }

  _createClass(_GraphQL, [{
    key: "encode",
    value: function encode(writer) {
      return writer.uint(48) && writer.string(this.operationKind) && writer.string(this.operationName) && writer.string(this.variables) && writer.string(this.response);
    }
  }]);

  return _GraphQL;
}();

export var GraphQL = bindNew(_GraphQL);
classes.set(48, GraphQL);

var _PerformanceTrack = /*#__PURE__*/function () {
  function _PerformanceTrack(frames, ticks, totalJSHeapSize, usedJSHeapSize) {
    _classCallCheck(this, _PerformanceTrack);

    this.frames = frames;
    this.ticks = ticks;
    this.totalJSHeapSize = totalJSHeapSize;
    this.usedJSHeapSize = usedJSHeapSize;
    this._id = 49;
  }

  _createClass(_PerformanceTrack, [{
    key: "encode",
    value: function encode(writer) {
      return writer.uint(49) && writer.int(this.frames) && writer.int(this.ticks) && writer.uint(this.totalJSHeapSize) && writer.uint(this.usedJSHeapSize);
    }
  }]);

  return _PerformanceTrack;
}();

export var PerformanceTrack = bindNew(_PerformanceTrack);
classes.set(49, PerformanceTrack);

var _ResourceTiming = /*#__PURE__*/function () {
  function _ResourceTiming(timestamp, duration, ttfb, headerSize, encodedBodySize, decodedBodySize, url, initiator) {
    _classCallCheck(this, _ResourceTiming);

    this.timestamp = timestamp;
    this.duration = duration;
    this.ttfb = ttfb;
    this.headerSize = headerSize;
    this.encodedBodySize = encodedBodySize;
    this.decodedBodySize = decodedBodySize;
    this.url = url;
    this.initiator = initiator;
    this._id = 53;
  }

  _createClass(_ResourceTiming, [{
    key: "encode",
    value: function encode(writer) {
      return writer.uint(53) && writer.uint(this.timestamp) && writer.uint(this.duration) && writer.uint(this.ttfb) && writer.uint(this.headerSize) && writer.uint(this.encodedBodySize) && writer.uint(this.decodedBodySize) && writer.string(this.url) && writer.string(this.initiator);
    }
  }]);

  return _ResourceTiming;
}();

export var ResourceTiming = bindNew(_ResourceTiming);
classes.set(53, ResourceTiming);

var _ConnectionInformation = /*#__PURE__*/function () {
  function _ConnectionInformation(downlink, type) {
    _classCallCheck(this, _ConnectionInformation);

    this.downlink = downlink;
    this.type = type;
    this._id = 54;
  }

  _createClass(_ConnectionInformation, [{
    key: "encode",
    value: function encode(writer) {
      return writer.uint(54) && writer.uint(this.downlink) && writer.string(this.type);
    }
  }]);

  return _ConnectionInformation;
}();

export var ConnectionInformation = bindNew(_ConnectionInformation);
classes.set(54, ConnectionInformation);

var _SetPageVisibility = /*#__PURE__*/function () {
  function _SetPageVisibility(hidden) {
    _classCallCheck(this, _SetPageVisibility);

    this.hidden = hidden;
    this._id = 55;
  }

  _createClass(_SetPageVisibility, [{
    key: "encode",
    value: function encode(writer) {
      return writer.uint(55) && writer.boolean(this.hidden);
    }
  }]);

  return _SetPageVisibility;
}();

export var SetPageVisibility = bindNew(_SetPageVisibility);
classes.set(55, SetPageVisibility);

var _LongTask = /*#__PURE__*/function () {
  function _LongTask(timestamp, duration, context, containerType, containerSrc, containerId, containerName) {
    _classCallCheck(this, _LongTask);

    this.timestamp = timestamp;
    this.duration = duration;
    this.context = context;
    this.containerType = containerType;
    this.containerSrc = containerSrc;
    this.containerId = containerId;
    this.containerName = containerName;
    this._id = 59;
  }

  _createClass(_LongTask, [{
    key: "encode",
    value: function encode(writer) {
      return writer.uint(59) && writer.uint(this.timestamp) && writer.uint(this.duration) && writer.uint(this.context) && writer.uint(this.containerType) && writer.string(this.containerSrc) && writer.string(this.containerId) && writer.string(this.containerName);
    }
  }]);

  return _LongTask;
}();

export var LongTask = bindNew(_LongTask);
classes.set(59, LongTask);

var _SetNodeAttributeURLBased = /*#__PURE__*/function () {
  function _SetNodeAttributeURLBased(id, name, value, baseURL) {
    _classCallCheck(this, _SetNodeAttributeURLBased);

    this.id = id;
    this.name = name;
    this.value = value;
    this.baseURL = baseURL;
    this._id = 60;
  }

  _createClass(_SetNodeAttributeURLBased, [{
    key: "encode",
    value: function encode(writer) {
      return writer.uint(60) && writer.uint(this.id) && writer.string(this.name) && writer.string(this.value) && writer.string(this.baseURL);
    }
  }]);

  return _SetNodeAttributeURLBased;
}();

export var SetNodeAttributeURLBased = bindNew(_SetNodeAttributeURLBased);
classes.set(60, SetNodeAttributeURLBased);

var _SetCSSDataURLBased = /*#__PURE__*/function () {
  function _SetCSSDataURLBased(id, data, baseURL) {
    _classCallCheck(this, _SetCSSDataURLBased);

    this.id = id;
    this.data = data;
    this.baseURL = baseURL;
    this._id = 61;
  }

  _createClass(_SetCSSDataURLBased, [{
    key: "encode",
    value: function encode(writer) {
      return writer.uint(61) && writer.uint(this.id) && writer.string(this.data) && writer.string(this.baseURL);
    }
  }]);

  return _SetCSSDataURLBased;
}();

export var SetCSSDataURLBased = bindNew(_SetCSSDataURLBased);
classes.set(61, SetCSSDataURLBased);

var _TechnicalInfo = /*#__PURE__*/function () {
  function _TechnicalInfo(type, value) {
    _classCallCheck(this, _TechnicalInfo);

    this.type = type;
    this.value = value;
    this._id = 63;
  }

  _createClass(_TechnicalInfo, [{
    key: "encode",
    value: function encode(writer) {
      return writer.uint(63) && writer.string(this.type) && writer.string(this.value);
    }
  }]);

  return _TechnicalInfo;
}();

export var TechnicalInfo = bindNew(_TechnicalInfo);
classes.set(63, TechnicalInfo);

var _CustomIssue = /*#__PURE__*/function () {
  function _CustomIssue(name, payload) {
    _classCallCheck(this, _CustomIssue);

    this.name = name;
    this.payload = payload;
    this._id = 64;
  }

  _createClass(_CustomIssue, [{
    key: "encode",
    value: function encode(writer) {
      return writer.uint(64) && writer.string(this.name) && writer.string(this.payload);
    }
  }]);

  return _CustomIssue;
}();

export var CustomIssue = bindNew(_CustomIssue);
classes.set(64, CustomIssue);

var _PageClose = /*#__PURE__*/function () {
  function _PageClose() {
    _classCallCheck(this, _PageClose);

    this._id = 65;
  }

  _createClass(_PageClose, [{
    key: "encode",
    value: function encode(writer) {
      return writer.uint(65);
    }
  }]);

  return _PageClose;
}();

export var PageClose = bindNew(_PageClose);
classes.set(65, PageClose);

var _CSSInsertRuleURLBased = /*#__PURE__*/function () {
  function _CSSInsertRuleURLBased(id, rule, index, baseURL) {
    _classCallCheck(this, _CSSInsertRuleURLBased);

    this.id = id;
    this.rule = rule;
    this.index = index;
    this.baseURL = baseURL;
    this._id = 67;
  }

  _createClass(_CSSInsertRuleURLBased, [{
    key: "encode",
    value: function encode(writer) {
      return writer.uint(67) && writer.uint(this.id) && writer.string(this.rule) && writer.uint(this.index) && writer.string(this.baseURL);
    }
  }]);

  return _CSSInsertRuleURLBased;
}();

export var CSSInsertRuleURLBased = bindNew(_CSSInsertRuleURLBased);
classes.set(67, CSSInsertRuleURLBased);

var _MouseClick = /*#__PURE__*/function () {
  function _MouseClick(id, hesitationTime, label, selector) {
    _classCallCheck(this, _MouseClick);

    this.id = id;
    this.hesitationTime = hesitationTime;
    this.label = label;
    this.selector = selector;
    this._id = 69;
  }

  _createClass(_MouseClick, [{
    key: "encode",
    value: function encode(writer) {
      return writer.uint(69) && writer.uint(this.id) && writer.uint(this.hesitationTime) && writer.string(this.label) && writer.string(this.selector);
    }
  }]);

  return _MouseClick;
}();

export var MouseClick = bindNew(_MouseClick);
classes.set(69, MouseClick);

var _CreateIFrameDocument = /*#__PURE__*/function () {
  function _CreateIFrameDocument(frameID, id) {
    _classCallCheck(this, _CreateIFrameDocument);

    this.frameID = frameID;
    this.id = id;
    this._id = 70;
  }

  _createClass(_CreateIFrameDocument, [{
    key: "encode",
    value: function encode(writer) {
      return writer.uint(70) && writer.uint(this.frameID) && writer.uint(this.id);
    }
  }]);

  return _CreateIFrameDocument;
}();

export var CreateIFrameDocument = bindNew(_CreateIFrameDocument);
classes.set(70, CreateIFrameDocument);